import { GetPageByRouteQuery } from "apollo"
import { Suspense } from "react"
import { getBreadCrumbs, transformProperties } from "utils"
import Hero from "../Common/Hero"
import Contact from "./Contact"
import Payment from "./Payment"

type Props = {
  data: GetPageByRouteQuery
  locale: string
}

export default function Homepage({ data, locale }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  const heroBanner = blocks?.blocks?.find(
    (block: any) => block.blockType === "heroBanner",
  )
  const finePayment = blocks?.blocks?.find(
    (block: any) => block.blockType === "finePayment",
  )
  const contactUsBoxWithText = blocks?.blocks?.find(
    (block: any) => block.blockType === "contactUsBoxWithText",
  )
  return (
    <>
      <Hero data={heroBanner} breadCrumbs={breadCrumbs} />
      <Suspense>
        <Payment finePayment={finePayment} />
      </Suspense>
      <Contact data={contactUsBoxWithText} />
    </>
  )
}
